import { render, staticRenderFns } from "./NewVolume.vue?vue&type=template&id=7e20d056&scoped=true"
import script from "./NewVolume.vue?vue&type=script&lang=js"
export * from "./NewVolume.vue?vue&type=script&lang=js"
import style0 from "./NewVolume.vue?vue&type=style&index=0&id=7e20d056&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e20d056",
  null
  
)

export default component.exports